import { Injectable } from '@angular/core';
import {Http} from '@angular/http';
import {ParentService} from '../../pages/A2-utils/ParentClass/ParentService';
import {constant} from '../../app.constants';
import {map} from 'rxjs/operators';
import {DepotModel} from '../models/depot.model';
import {Observable} from 'rxjs';

@Injectable()
export class DepotService extends ParentService{

  constructor(
    private _http: Http
  ) {
    super();
  }

  get (providerId: number): Observable<DepotModel[]> {
    const url = `${constant.DEPOT.LIST_BY_PROVIDER + providerId}`;
    return this._http.get(url, this.getHeader())
      .pipe(
        map((resp: any) => resp.json() as DepotModel[])
      ).catch((error: any) => Observable.throw(error.json()));
  }
}



// WEBPACK FOOTER //
// ./src/app/core/services/depot.service.ts